import { useEffect, useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Container } from "@kmf/ui";
import kmfLogo from "@/assets/kmf-logo.svg";
import koreaIslamLogo from "@/assets/koreaislam-logo.png";

const navItems = [
  { label: "소개", href: "/about" },
  { label: "인증안내", href: "/cert" },
  { label: "공지사항", href: "/notices" },
  { label: "뉴스", href: "/news" },
  { label: "파트와", href: "/fatwas" },
  { label: "가이드", href: "/guide" },
];

export function Layout() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const languageHref = import.meta.env.DEV ? `http://${window.location.hostname}:3001/en/` : "/en/";

  useEffect(() => {
    setMenuOpen(false);
    if (location.hash) {
      requestAnimationFrame(() => document.getElementById(location.hash.slice(1))?.scrollIntoView());
    } else { window.scrollTo(0, 0); }
  }, [location.pathname, location.hash]);

  return (
    <div className="public-site" data-language="kr">
      <a className="skip-link" href="#main-content">본문 바로가기</a>
      <header className="site-header" onKeyDown={(event) => { if (event.key === "Escape") setMenuOpen(false); }}>
        <Container>
          <div className="header-content">
            <Link to="/" className="site-brand" aria-label="KMF 할랄위원회">
              <img src={kmfLogo} alt="" />
              <span><small>(재)한국이슬람교</small><strong>KMF 할랄위원회</strong></span>
            </Link>
            <nav className="desktop-navigation" aria-label="주 메뉴">
              {navItems.map((item) => <Link key={item.href} to={item.href} aria-current={location.pathname.startsWith(item.href) ? "page" : undefined}>{item.label}</Link>)}
            </nav>
            <div className="header-actions">
              <a href={languageHref} className="language-link" aria-label="EN">EN</a>
              <button className="menu-toggle" type="button" aria-expanded={menuOpen} aria-controls="mobile-navigation" onClick={() => setMenuOpen(!menuOpen)}>
                <span>{menuOpen ? "닫기" : "메뉴"}</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" aria-hidden="true"><path d={menuOpen ? "M4 4l12 12M4 16L16 4" : "M2 6h16M2 14h16"} /></svg>
              </button>
            </div>
          </div>
          {menuOpen && <nav id="mobile-navigation" className="mobile-navigation" aria-label="주 메뉴">
            {navItems.map((item) => <Link key={item.href} to={item.href} onClick={() => setMenuOpen(false)} aria-current={location.pathname.startsWith(item.href) ? "page" : undefined}>{item.label}<span aria-hidden="true">→</span></Link>)}
          </nav>}
        </Container>
      </header>
      <main id="main-content" className="public-main" tabIndex={-1}><Outlet /></main>
      <footer className="site-footer">
        <Container>
          <div className="footer-grid">
            <div className="footer-identity"><img src={koreaIslamLogo} alt="(재)한국이슬람교" /><p className="footer-title">KMF 할랄위원회</p><p>(재)한국이슬람교 산하 한국 최초의 국제 상호 인증 할랄 인증기관</p></div>
            <div><h2>문의 안내</h2><address>서울특별시 용산구 우사단로10길 39<br /><a href="tel:+8227936908">02-793-6908</a><br /><a href="mailto:info@kmfhalal.or.kr">info@kmfhalal.or.kr</a></address></div>
            <div><h2>바로가기</h2><div className="footer-links">{navItems.map((item) => <Link key={item.href} to={item.href}>{item.label}</Link>)}<Link to="/cert#mark-usage-rules">마크 사용 규칙</Link><Link to="/cert#halalcertifiedcompany">인증 업체 목록</Link></div></div>
          </div>
          <div className="footer-bottom"><span>© {new Date().getFullYear()} Korea Muslim Federation. All rights reserved.</span><span>KMF HALAL COMMITTEE</span></div>
        </Container>
      </footer>
    </div>
  );
}
